(() => {
  const i18n = window.cimbaliI18n;
  const menuButton = document.querySelector('.menu-button');
  const nav = document.querySelector('#navigation');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? i18n.menuClose : i18n.menuOpen);
    nav?.classList.toggle('open', open);
  });
  nav?.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
    nav.classList.remove('open'); menuButton?.setAttribute('aria-expanded', 'false');
  }));
  document.querySelectorAll('[data-year]').forEach(el => el.textContent = new Date().getFullYear());
  const tabs = [...document.querySelectorAll('[data-filter]')];
  const cards = [...document.querySelectorAll('.product-grid [data-category]')];
  tabs.forEach(tab => { const count = cards.filter(card => tab.dataset.filter === 'all' || card.dataset.category === tab.dataset.filter).length; const badge = document.createElement('sup'); badge.textContent = count; tab.append(document.createTextNode(' '), badge); });
  const search = document.querySelector('#model-search');
  const searchBox = document.querySelector('.catalog-search');
  let filter = 'all';
  function update() {
    const query = (search?.value || '').toLocaleLowerCase('sk'); let count = 0;
    cards.forEach(card => {
      const categoryMatch = filter === 'all' || card.dataset.category === filter;
      const match = categoryMatch && card.dataset.name.toLocaleLowerCase('sk').includes(query);
      card.hidden = !match; if (match) count++;
    });
    const empty = document.querySelector('#no-results'); if (empty) empty.hidden = count > 0;
    tabs.forEach(tab => { const active = tab.dataset.filter === filter; tab.classList.toggle('active', active); tab.setAttribute('aria-pressed', String(active)); });
  }
  tabs.forEach(tab => tab.addEventListener('click', () => { filter = tab.dataset.filter; update(); }));
  search?.addEventListener('input', update);
  document.querySelector('[data-search]')?.addEventListener('click', () => {
    if (!searchBox) return;
    searchBox.hidden = false; filter = 'all'; update();
    document.querySelector('#kolekcia')?.scrollIntoView({behavior:'smooth'}); search?.focus({preventScroll:true});
  });
  document.querySelector('[data-clear-search]')?.addEventListener('click', () => { search.value = ''; searchBox.hidden = true; filter = 'all'; update(); document.querySelector('[data-search]')?.focus({preventScroll:true}); });
  const requestedModel = new URLSearchParams(location.search).get('model');
  if (requestedModel) {
    const field = document.querySelector('[name="contact[body]"]');
    if (field && !field.value.trim()) field.value = new URLSearchParams(location.search).get('context')?.slice(0,4000) || `${i18n.interestPrefix} ${requestedModel.slice(0,200)}.\n\n`;
  }
  const variant = document.querySelector('[data-variant-select]');
  variant?.addEventListener('change', () => {
    const option = variant.selectedOptions[0]; const price = document.querySelector('[data-variant-price]');
    if (price) price.textContent = option.dataset.price;
    const gross = document.querySelector('[data-variant-gross]'); if (gross) gross.textContent = option.dataset.gross;
    const button = document.querySelector('[data-add-to-cart]');
    if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? i18n.unavailable : i18n.addToCart; }
  });
  document.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
    const main = document.querySelector('[data-product-image]');
    if (!main) return;
    const next = button.querySelector('[data-gallery-template]')?.content.firstElementChild?.cloneNode(true);
    if (next?.tagName === 'IMG') { main.replaceWith(next); return; }
    main.srcset = ''; main.src = button.dataset.gallerySrc; main.alt = button.querySelector('img')?.alt || '';
  }));
})();
